import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape( {
  firstName: Yup.string()
  .min( 2, 'Too Short!' )
  .max( 50, 'Too Long!' )
  .required( '* First name is Required.' ),
  lastName: Yup.string()
  .min( 2, 'Too Short!' )
  .max( 50, 'Too Long!' )
  .required( '* Surname is Required.' ),
  phone: Yup.string()
  .required( '* Phone number is Required.' ),
  email: Yup.string()
  .email( '* Enter a Valid Email.' )
  .required( '* Email is Required.' ),
  message: Yup.string()
  .required( '* Message is Required.' ),
  referral: Yup.string()
  .required( '* Referral is Required.' ),
  subscribe: Yup.boolean(),
} );

const encode = ( data ) => {
  return Object.keys( data )
  .map( key => encodeURIComponent( key ) + '=' + encodeURIComponent( data[ key ] ) )
  .join( '&' )
};

function GeneralForm() {

  return (
    <>
      <Formik
        initialValues={{
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          message: '',
          referral: '',
          subscribe: false,
        }}
        validationSchema={validationSchema}
        onSubmit={( values, { setSubmitting } ) => {

          fetch( '/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: encode( {
              'form-name': 'general-form',
              ...values,
            } ),
          } )
          .then( () => {
            alert( 'Thanks! We have received your message and will get back to you ASAP.' );
            setSubmitting( false )
          } )
          .catch( error => {
            alert( 'Something went wrong! Could you please try again or email us directly.' );
            setSubmitting( false )
          } )

        }}>
        {( { isSubmitting, values, handleChange } ) => (
          <Form className='form'
            method="post"
            name='general-form'
            data-netlify='true'
            data-netlify-honeypot='bot-field'
          >
            <div className='two-col-fields'>
              <div className='field-holder'>
                <label htmlFor='firstName' className='label'>First Name</label>
                <Field
                  className='input'
                  type='text'
                  name='firstName'
                  placeholder="first name*"
                />
                <ErrorMessage className="errorMsg" name="firstName" component="small"/>
              </div>
              <div className='field-holder'>
                <label htmlFor='lastName' className='label'>Surname</label>
                <Field
                  className='input'
                  type='text'
                  name='lastName'
                  placeholder="surname*"
                />
                <ErrorMessage className="errorMsg" name="lastName" component="small"/>
              </div>
            </div>
            <div className='field-holder'>
              <label htmlFor='email' className='label'>Email</label>
              <Field
                className='input'
                type='text'
                name='email'
                placeholder="email address*"
              />
              <ErrorMessage className="errorMsg" name="email" component="small"/>
            </div>
            <div className='two-col-fields'>
              <div className='field-holder'>
                <label htmlFor='phone' className='label'>Phone no.</label>
                <Field
                  className='input'
                  type='text'
                  name='phone'
                  placeholder="phone no.*"
                />
                <ErrorMessage className="errorMsg" name="phone" component="small"/>
              </div>
            </div>

            <div className='field-holder'>
              <label htmlFor='message' className='label'>How can we help you?</label>
              <Field
                className='input-textarea'
                name='message'
                component='textarea'
                rows='3'
                placeholder="how can we help you?*"
              />
              <ErrorMessage className="errorMsg" name="message" component="small"/>
            </div>

            <div className='two-col-fields'>
              <div className='field-holder'>
                <div className="select">
                  <label htmlFor='referral' className='label'>How did you hear about us?</label>

                  <Field as="select" name="referral">
                    <option value="" disabled>How did you hear about us?*</option>
                    <option value="attended-event">Attended event</option>
                    <option value="google-search">Google search</option>
                    <option value="previous-dining-experience">Previous dining experience</option>
                    <option value="referral">Referral</option>
                    <option value="social-media-fb">Social Media – Facebook</option>
                    <option value="social-media-instagram">Social Media – Instagram</option>
                  </Field>
                </div>
                <ErrorMessage className="errorMsg" name="referral" component="small"/>
                </div>
            </div>

            <label htmlFor='subscribe' className="checkbox">
              <Field type="checkbox" id="subscribe" name="subscribe" checked={values.subscribe} onChange={handleChange}/>
              <div className="checkmark"/>
              <span className="label">Yes, I would like to stay
                up-to-date with The Marion and receive newsletters</span>
            </label>

            <div className="submit-holder">
              <input name='submit' type='submit' disabled={isSubmitting} value='Send Enquiry'
                className='button dark'/>
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default GeneralForm;
